export default __webpack_public_path__ + "static/media/167.1da2ec1a.png";